import { bdcRepository } from './Repository'
import { concatenationUrl } from '@/utils/index'

const resource = 'orders'
export default {
  getOrders(customerApiToken = null) {
    const endpoint = `${resource}`
    const qsParams = {
      customerApiToken: customerApiToken,
    }

    return bdcRepository.get(concatenationUrl`/${endpoint}?${qsParams}`)
  },
  getOrder(id, customerApiToken = null) {
    const endpoint = `${resource}/${id}`
    const qsParams = {
      customerApiToken: customerApiToken,
    }

    return bdcRepository.get(concatenationUrl`/${endpoint}?${qsParams}`)
  },
  postOrder({ cart, orderContent }, customerApiToken = null) {
    const endpoint = `${resource}`
    const qsParams = {
      customerApiToken: customerApiToken,
    }

    return bdcRepository.post(concatenationUrl`/${endpoint}?${qsParams}`, {
      cart: cart,
      customID: orderContent.customID,
      comments: orderContent.comments,
    }, {
      transformRequest: [(data) => JSON.stringify(data)],
    })
  },
}